import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate {
  constructor(
    private router: Router,
    private authService: AuthService,
  ) { }

  canActivate(): boolean {
    // Tokens live in httpOnly cookies. loggedInUser only records that a session exists.

    if (!this.authService.isLoggedIn()) {
      console.warn("AuthGuard: not logged in, redirecting to /login");
      this.router.navigate(['/login']);
      return false;
    }

    // Access-token expiry is handled by refreshing. Idle time and the age of
    // the original login do not end the session.
    return true;
  }
}
